/**
 * Generates test IDs for a given scope and list of keys.
 * @param scope The scope to use as a prefix for the generated test IDs.
 * @param keys An array of keys to generate test IDs for.
 * @returns An object with keys as specified in the input array and values as generated test IDs.
 */
export const generateTestIds = <T extends string>(
  scope: string,
  keys: readonly T[],
): Record<T, string> => {
  if (!scope) {
    throw new Error('Scope must be provided');
  }

  const testIds = {} as Record<T, string>;

  keys.forEach(key => {
    testIds[key] = `${scope}.${key}`;
  });

  return testIds;
};
